import React, { useState } from "react";
import {
  Checkbox,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Draggable from "react-draggable";
import theme from "theme";
import SC from "./style";

const PaperComponent = (props) => {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
      bounds="parent"
    >
      <Paper {...props} />
    </Draggable>
  );
};

const ColumnVisibilityOptions = ({
  title = "",
  options = [],
  checkedList = [],
  setCheckedList = () => console.error("setCheckedList props missing"),
  openModal = false,
  handleCloseModal = () => console.error("handleCloseModal props missing"),
}) => {
  const [filteredOptions, setFilteredOptions] = useState(options);

  const selectAll = options.length > 0 && checkedList.length === options.length;

  const handleSelectAllChange = () => {
    setCheckedList((prevCheckedList) => {
      const newCheckedList = selectAll ? [] : options.map(({ value }) => value);
      return newCheckedList;
    });
  };

  const handleCheckboxChange = (value) => {
    setCheckedList((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const handleSearchChange = (e) => {
    const newData = options.filter((item) =>
      item.label.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setFilteredOptions(newData);
  };

  return (
    <>
      {SC.GlobalStyles}
      <Dialog
        open={openModal}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        onClose={handleCloseModal}
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          <SC.DialogTitle>{title || "Text"}</SC.DialogTitle>
        </DialogTitle>

        <IconButton
          edge="end"
          color="inherit"
          onClick={handleCloseModal}
          aria-label="close"
          sx={{ position: "absolute", right: 12, top: 5 }}
        >
          <CloseIcon />
        </IconButton>

        <ListItem
          sx={{
            padding: "2px 2px 2px 0px",
            backgroundColor: "white",
            margin: "0px 0px 0px 0px",
            borderBottom: `1px solid ${theme.colors.bordertask}`,
          }}
        >
          <Checkbox checked={selectAll} onChange={handleSelectAllChange} />
          <SC.InputField
            type="search"
            placeholder="Search"
            onChange={handleSearchChange}
          />
        </ListItem>
        <DialogContent>
          <SC.DialogContent>
            <List>
              {filteredOptions.map(({ value, label }) => (
                <ListItem
                  sx={{
                    borderTop: `1px solid ${theme.colors.bordertask}`,
                    padding: "0px",
                    backgroundColor: "white",
                  }}
                  key={value}
                >
                  <Checkbox
                    checked={checkedList.includes(value)}
                    onChange={() => handleCheckboxChange(value)}
                    name={value}
                  />
                  <ListItemText sx={{ marginLeft: 2 }} primary={label} />
                </ListItem>
              ))}
            </List>
          </SC.DialogContent>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ColumnVisibilityOptions;
